import Vue from 'vue'
import VueRouter from 'vue-router'
import LoginView from '../views/LoginView.vue'
import botRoutes from './bot'
import dispositivosMedicosRoutes from './dispositivos-medicos'
import tratamientosEspecialesBotRoutes from './tratamientos-especiales-bot'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'login',
    component: LoginView
  },
  {
    path: '/whatsapp/:remito/:multiple?/:cliente?',
    name: 'whatsapp',
    component: () => import('../views/WhatsappView.vue'),
    meta: { requiresAuth: false }
  },

  {
    path: '/pruebas',
    name: 'pruebas',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "about" */ '../views/pruebas.vue')
  },
  {
    path: '/manual',
    name: 'manual',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "about" */ '../views/manual.vue')
  },
  {
    path: '/ayuda',
    name: 'ayuda',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "about" */ '../views/ayuda.vue')
  },
  {
    path: '/normalizador',
    name: 'normalizador',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "about" */ '../views/normalizador.vue')
  },
  {
    path: '/home',
    name: 'inicio',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "about" */ '../views/InicioView.vue')
  },
  {
    path: '/convenios',
    name: 'convenios',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "about" */ '../views/ConveniosView.vue')
  },
  {
    path: '/detalle/:tipconv/:campo',
    name: 'detalle',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "about" */ '../views/DetalleView.vue')
  },
  {
    path: '/recetas/:tipconv',
    name: 'recetas',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "about" */ '../views/RecetasView.vue')
  },
  {
    path: '/receta/:receta',
    name: 'receta',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "about" */ '../views/DetalleReceta.vue')
  },
  {
    path: '/dispensas',
    component: () => import('../views/tto/layout.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: 'liquidaciones',
        name: 'ttoliq',
        props: true,
        component: () => import('../views/tto/liquidaciones.vue')
      },
      {
        path: 'farmacias',
        name: 'ttofarm',
        props: true,
        component: () => import('../views/tto/farmacias.vue')
      },
      {
        path: 'convenios',
        name: 'ttoconv',
        props: true,
        component: () => import('../views/tto/admin/convenios.vue')
      },
      {
        path: 'colegio',
        name: 'ttocolegio',
        props: true,
        component: () => import('../views/tto/colegios.vue')
      },
      {
        path: 'log-in',
        name: 'ttologin',
        props: true,
        component: () => import('../views/tto/logIn.vue')
      },
      {
        path: 'admin',
        name: 'tools',
        props: true,
        component: () => import('../views/tto/admin/admin.vue')
      },
      {
        path: 'ted',
        name: 'ttoted',
        props: true,
        component: () => import('../views/tto/ted.vue')
      },

      {
        path: 'afiliados',
        name: 'ttoafiliado',
        props: true,
        component: () => import('../views/tto/afiliados.vue')
      },
      {
        path: 'afiliadosFAC',
        name: 'ttoafiliadof',
        props: true,
        component: () => import('../views/tto/afiliadosFAC.vue')
      },
      {
        path: 'farmacity',
        name: 'ttofarmacity',
        props: true,
        component: () => import('../views/tto/farmacity.vue')
      },


      {
        path: 'farmacia/:id_cliente',
        name: 'detalleFarm',
        props: true,
        component: () => import('../views/tto/detalleFarm.vue')
      },

      {
        path: 'buscador',
        name: 'ttobusca',
        props: true,
        component: () => import('../views/tto/buscador.vue')
      },
      {
        path: 'liquidacion/:liq_id',
        name: 'ttoliq_detalle',
        props: true,
        component: () => import('../views/tto/liquidacion.vue')
      }
    ]
  },
  ...botRoutes,
  ...dispositivosMedicosRoutes,
  ...tratamientosEspecialesBotRoutes
]

const router = new VueRouter({
  routes
})
router.beforeEach((to, from, next) => {
  // console.log(to);

  // Manejar títulos y metadatos dinámicamente
  if (to.meta && to.meta.title) {
    document.title = to.meta.title;

    // Actualizar metatags si están disponibles
    if (to.meta.description) {
      let metaDescription = document.querySelector('meta[name="description"]');
      if (!metaDescription) {
        metaDescription = document.createElement('meta');
        metaDescription.name = 'description';
        document.head.appendChild(metaDescription);
      }
      metaDescription.content = to.meta.description;
    }
  }

  if (to.matched.some(record => record.meta.requiresAuth)) {

    let auth = window.sessionStorage.getItem('numero') ? window.sessionStorage.getItem('numero') : 0
    console.log('at', auth)
    if (!auth) {
      next({
        path: '/',
        query: { origen: to.fullPath }
      })
    } else {
      next()
    }
  } else {
    next() // make sure to always call next()!
  }
})



export default router
